import type { CloudProvider } from '../types'

// One event per playback session, not per pause/resume. Retries keep the same ID
// so a response lost after a server commit cannot increment the count twice.
export class PlaybackSessions {
  private current: { key: string; eventId: string; sent: boolean; pending: Promise<void> | null } | null = null
  constructor(private readonly send: (videoId: string, provider: CloudProvider, eventId: string, roomId: string | null) => Promise<void>) {}
  end() { this.current = null }
  async play(videoId: string, provider: CloudProvider, roomId: string | null): Promise<void> {
    const key = JSON.stringify([roomId, provider, videoId])
    if (this.current?.key !== key) this.current = { key, eventId: crypto.randomUUID(), sent: false, pending: null }
    const session = this.current
    if (session.sent) return
    if (session.pending) return session.pending
    session.pending = (async () => {
      for (let attempt = 0; attempt < 3; attempt++) {
        try { await this.send(videoId, provider, session.eventId, roomId); session.sent = true; return }
        catch (error) {
          if (error instanceof Error && 'status' in error && Number(error.status) >= 400 && Number(error.status) < 500 && Number(error.status) !== 429) throw error
          if (attempt === 2) throw error
          await new Promise(resolve => setTimeout(resolve, 500 * (attempt + 1)))
        }
      }
    })()
    try { await session.pending } finally { session.pending = null }
  }
}
